import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorPage from '../../../shared/pages/errorPage/errorPage';

const DEFAULT_MESSAGE =
    'Your payment was not completed and nothing has been charged. Please try again.';

const AmeriaError: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const goToTechForAll = () => {
        window.location.href = `${process.env.REACT_APP_TECH_FOR_ALL_ORIGIN_URL}`;
    };

    return (
        <ErrorPage
            title={location.state?.title || 'Payment not completed'}
            message={location.state?.message || DEFAULT_MESSAGE}
            primaryAction={{ label: 'Try again', onClick: () => navigate('/') }}
            secondaryAction={{ label: 'Back to Tech For All', onClick: goToTechForAll }}
        />
    );
};

export default AmeriaError;
